import { DropdownField } from '@hb/shared'
import { FC, forwardRef } from 'react'
import { InputElement, InputProps } from '../../../../types/fields'
import { InputRef } from '../types'
import { ButtonsDropdownInput } from './ButtonsDropdownInput'
import { MenuDropdownInput } from './MenuDropdownInput'
import { RadioInput } from './RadioInput'
import { SelectInput } from './SelectInput'

const ComponentMap: Record<Required<DropdownField>['inputType'], FC<InputProps<DropdownField>>> = {
  native: SelectInput,
  menu: MenuDropdownInput,
  radio: RadioInput,
  buttons: ButtonsDropdownInput,
}

export const DropdownInput: InputElement<DropdownField> = forwardRef<
  InputRef,
  InputProps<DropdownField>
>((props, ref) => {
  const Component = ComponentMap[props.field.inputType ?? 'menu']
  return <Component {...props} ref={ref} />
})
